import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'

import * as R from 'ramda'
import React, { FC } from 'react'
import styled from 'styled-components'

import CompanyTableBody from '../../components/companyTableBody'
import { Pagination } from '../../interfaces/common'
import { CompanyListInterface } from '../../interfaces/company'
import TablePaperContainer from '../common/TablePaperContainer'

const StyledTableHead = styled(TableHead)`
  background-color: rgba(0, 0, 0, 0.02);
`

const StyledTableHeadCell = styled(TableCell)`
  font-size: 16px !important;
  font-weight: 700 !important;
`

type Props = {
  companyList: Pagination<CompanyListInterface> | null
  handleChangePage: (...args: any) => void
  handleChangeRowsPerPage: (...args: any) => void
}

const CompanyListTable: FC<Record<string, unknown> & Props> = ({
  companyList,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  const companies = R.pathOr([], ['result'], companyList)
  const page = R.pathOr(1, ['page'], companyList)
  const limit = R.pathOr(50, ['limit'], companyList)
  const total = R.pathOr(0, ['total'], companyList)

  const columnNameList = [
    'Id',
    'Profile #',
    'Country',
    'Category',
    'Status',
    'Verified',
    'Created At',
    'Updated At',
    'Updated By'
  ]

  return (
    <TablePaperContainer>
      <TableContainer component={Paper} style={{ height: 'inherit' }}>
        <Table aria-label="sticky pagination table">
          <StyledTableHead>
            <TableRow>
              {columnNameList.map((name) => (
                <StyledTableHeadCell align="center">{name}</StyledTableHeadCell>
              ))}
            </TableRow>
          </StyledTableHead>
          <CompanyTableBody companies={companies} />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        count={total}
        rowsPerPage={limit}
        page={page - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ minWidth: '500px' }}
      />
    </TablePaperContainer>
  )
}

export default CompanyListTable
